import { Clickable, Col, Row, Text } from 'components';
import { theme } from 'lib';

const SegmentControl = ({ options, selectedIdx, handleSelect }) => {
  return (
    <Col wid="100%">
      <Row start>
        {options.map((x, i) => (
          <Clickable key={i} onClick={() => handleSelect(i)}>
            <Col noFlex pad="14px 24px 8px">
              <Text b2 bold col={selectedIdx === i ? '#000' : theme.GREY_60}>
                {x.title}
              </Text>
            </Col>

            {selectedIdx === i && (
              <Col noFlex wid="100%" ht="4px" marg="0 0 -1px" bg={theme.SECONDARY} />
            )}
          </Clickable>
        ))}
      </Row>

      <Row wid="100%" ht="1px" bg={theme.GREY_20} />
    </Col>
  );
};

export default SegmentControl;
